export default "__VITE_PUBLIC_ASSET__3e6d0ba5__"